import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { LoginServiceService } from "../Services/login-service.service";
import { User } from "../Services/WOWApi.Service";
import { CustomServiceService } from "../Services/custom-service.service";
@Injectable()
export class CheckHost  {
    loggedUser: User;
    constructor(private router:Router, private customServices:CustomServiceService) {
 
    }
    canActivate(route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean|UrlTree {
let url: string = state.url;
this.loggedUser = this.customServices.GetLoggedInUser();
if (this.loggedUser == null) {
     
    return false;            
}
else
{
   if(!this.loggedUser.isHost)
    {
        return false;
    }

}

return true;
}
}